(() => {
    const capcod = window.capcod;

    const progressBar = document.querySelector('[data-read-progress]');
    const article = document.querySelector('[data-article]');
    if (capcod && progressBar && article) {
        capcod.onScroll((y) => {
            const h = article.offsetHeight - window.innerHeight;
            const p = Math.max(0, Math.min(1, (y - article.offsetTop + 120) / Math.max(1, h)));
            progressBar.style.width = (p * 100) + '%';
        });
    }

    const COPY_FEEDBACK_MS = 2000;
    const COPIED_CLASS = 'is-copied';
    const FAILED_CLASS = 'is-failed';
    let copyTimer = 0;

    const copyToClipboard = (text) => {
        if (!window.isSecureContext || !navigator.clipboard) {
            return Promise.reject(new Error('Clipboard API unavailable'));
        }
        return navigator.clipboard.writeText(text);
    };

    const showCopyFeedback = (btn, stateClass, label) => {
        const status = btn.parentElement.querySelector('[data-copy-status]');
        btn.classList.remove(COPIED_CLASS, FAILED_CLASS);
        btn.classList.add(stateClass);
        if (status) {
            status.textContent = label;
        }

        clearTimeout(copyTimer);
        copyTimer = setTimeout(() => {
            btn.classList.remove(stateClass);
            if (status) {
                status.textContent = '';
            }
        }, COPY_FEEDBACK_MS);
    };

    document.addEventListener('click', (e) => {
        const cp = e.target.closest('[data-copy-link]');
        if (!cp) return;
        e.preventDefault();
        const url = cp.getAttribute('data-copy-link');
        copyToClipboard(url)
            .then(() => showCopyFeedback(cp, COPIED_CLASS, cp.getAttribute('data-copied-label')))
            .catch(() => showCopyFeedback(cp, FAILED_CLASS, cp.getAttribute('data-failed-label')));
    });
})();
